import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const CardItemWrapper = styled.div`
  height: 400px;
  padding: 15px;
  width: 25%;
  ${mediaQuery('desktop')} {
    width: ${(1 / 3) * 100}%;
  }
  ${mediaQuery('medium')} {
    width: 50%;
  }

  ${mediaQuery('tablet')} {
    width: 100%;
  } ;
`;

export const ShowLittersWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 700;
  color: ${(props) => props.theme.color.blue.default};
  font-size: 18px;
  & > *:not(:last-child) {
    margin-right: 10px;
  }
`;

export const EmptyWrapper = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;
  margin-top: 100px;
  & > *:not(:last-child) {
    margin-bottom: 20px;
  }
  padding: 50px;
  text-align: center;
  max-width: 700px;
  margin: 0 auto;
  color: ${(props) => props.theme.color.medium.default};

  ${mediaQuery('small')} {
    padding: 20px;
  } ;
`;
